<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { ENTITIES, OPERATION, USERS_FIELDS } from '@/services/charts-service';
import { calculateVariation } from '@/utils/math';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';

export default {
  name: 'FansTotalCompetitive',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      await this.getChartsService({
        itemId: this.itemId,
        method: 'getDataWithDisplaceRange',
        entity: ENTITIES.USERS,
        points_parser: '',
        params: {
          fields: [USERS_FIELDS.FOLLOWERS],
          grouping: [USERS_FIELDS.CHANNEL, USERS_FIELDS.UID, USERS_FIELDS.USERNAME],
          operators: OPERATION.LAST,
        },
      })
        .then(response => {
          this.rawData = response;

          const { currentPeriod, displacedPeriod } = this.rawData;

          const currentValue = this.getReducedPeriodValue(currentPeriod);
          const previousValue = this.getReducedPeriodValue(displacedPeriod);

          const variation = calculateVariation(previousValue, currentValue);

          this.value = currentValue;
          this.variation = variation;
          this.rawVariation = variation;
          this.comparationValue = formatSocialNumberWithDecimal(previousValue);
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    getReducedPeriodValue(period) {
      return period.points.reduce((acc, { value }) => acc + value, 0);
    },
  },
};
</script>

